import { render, staticRenderFns } from "./PresentationUploader.vue?vue&type=template&id=e2e4fee8"
import script from "./PresentationUploader.vue?vue&type=script&lang=js"
export * from "./PresentationUploader.vue?vue&type=script&lang=js"
import style0 from "./PresentationUploader.vue?vue&type=style&index=0&id=e2e4fee8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports